module.exports = __webpack_public_path__ + "img/accessibility_en.cd52d33.jpg";